const ValidationExportTypes = {
  WORKBOOK: "workbook",
  ERROR_LOG: "errorLog",
  ORIGINAL: "original"
} as const;

export default ValidationExportTypes;
